import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import {
    GridColDef,
    GridPaginationModel,
    GridRowParams,
} from '@mui/x-data-grid';

import { DataGrid, DataGridCard } from '@barboxx/admin-components';
import { usePaging } from '@barboxx/admin-utils';
import Api from '@barboxx/api';
import { Customer } from '@barboxx/models';

type Column = GridColDef<Customer>;

const COLUMNS: Column[] = [
    {
        field: 'isInternal',
        headerName: 'Internal',
        width: 100,
        type: 'boolean',
    },
    { field: 'id', headerName: 'Id', width: 70 },
    { field: 'firstName', headerName: 'First Name', width: 170, flex: 1 },
    { field: 'lastName', headerName: 'Last Name', width: 170, flex: 1 },
    {
        field: 'email',
        headerName: 'Email',
        width: 170,
        flex: 1,
    },
];

interface Props {
    searchString?: string;
}

export function CustomerTable({ searchString }: Props) {
    const navigate = useNavigate();

    const { page, size, sort, updatePageModel, updateSort } = usePaging();

    const { data, isLoading, error } = useQuery({
        queryKey: ['customers', page, size, sort, searchString],
        queryFn: () =>
            Api.Customers.getCustomers({ page, size, sort, searchString }),
    });

    const handleChangePageModel = (pageModel: GridPaginationModel) => {
        updatePageModel(pageModel);
    };

    const handleRowClick = (param: GridRowParams) => {
        navigate(`${param.id}`);
    };

    return (
        <DataGridCard>
            <DataGrid
                columns={COLUMNS}
                disableColumnMenu
                disableRowSelectionOnClick
                error={error}
                loading={isLoading}
                onRowClick={handleRowClick}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onSortModelChange={updateSort}
                rows={data?.data?.results ?? []}
                onPaginationModelChange={handleChangePageModel}
                rowCount={data?.data?.total ?? 0}
            />
        </DataGridCard>
    );
}
